module.exports = __webpack_public_path__ + "static/media/order.afaf127a.svg";